export default __webpack_public_path__ + "static/SRF 0085 - Fiche de spécifications et données techniques-3c9069f65cdc82b9787ee035ba81ddb4.pdf";